import React from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

function DeleteModal({ modalDelete, setModalDelete, deleteItem }) {
	const { t } = useTranslation()

	return (
		<>
			<Modal show={modalDelete} animation={false}
				centered dialogClassName="update-modal-width" backdrop="static"
				onHide={() => setModalDelete(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('delete')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{t('are_you_sure_you_want_delete')}
				</Modal.Body>
				<Modal.Footer >
					<div className="d-flex gap-2 w-100">
						<button className="btn btn-warning w-100" onClick={() => setModalDelete(false)}>
							{t('cancel')}
						</button>
						<button className="btn btn-danger w-100" onClick={() => deleteItem()}>{t('delete')}</button>
					</div>
				</Modal.Footer>
			</Modal>
		</>
	)
}

export default DeleteModal
